import detailsJSon from '../../data/structure/structure.json';

const RecentInsightsKidsQuran=({recentInsightsArr})=>{
    const maxIndex=5;

    const setMushafLocalStorage=(surahId,sName)=>{
        return Promise.resolve().then(function () {
            const surahData={snum:surahId,sname:sName}
            localStorage.setItem("mushafSurahSidebar", JSON.stringify(surahData));
        });
    }

    const navigateMushaf=(surId,mushafPage)=>{
        const surahElement = document.getElementById('surahNavigationPageData' + surId);
        const surahPage = surahElement.getAttribute("data-surahPage");
        const surahId = surahElement.getAttribute("data-surahnum");
        const surahName = surahElement.getAttribute("data-surahname");

        const finalPage = Number(mushafPage)>Number(surahPage)?mushafPage:surahPage;
    
        setMushafLocalStorage(surahId, surahName).then(function() {
            window.location = '/quran/read-mushaf/' + finalPage;
        });
    }

    return(
        <>
            {
                recentInsightsArr.map((item,itemIndex)=>{
                    if(itemIndex<=maxIndex)
                    {
                        let surahLink,pageType;
                        const surahData=detailsJSon[parseInt(item.surahNumber)-1];
                
                        if(item.pageType&&item.pageType==="recite-surah-bookmark")
                        {
                            surahLink=`/kids-quran/recite-surah/${parseInt(item.surahNumber)}?qRef=${item.scrollPos}`;
                            pageType='Recitation';
                        }
                        else if(item.pageType&&item.pageType==="read-surah")
                        {
                            surahLink=`/kids-quran/${item.pageType}/${parseInt(item.surahNumber)}?resume=${item.scrollPos}`;
                            pageType="Translation";
                        }
                        else if(item.pageType&&item.pageType==="read-mushaf")
                        {
                            surahLink=`/quran/${item.pageType}/${item.scrollPos}`;
                            pageType="Mushaf";
                        }
                        else
                        {
                            surahLink=`/kids-quran/recite-surah/${parseInt(item.surahNumber)}`;
                            pageType="Recitation";
                        }

                        return(
                            <div key={itemIndex} className="mb-4 md:mb-0 recent-tile">
                                {
                                    item.pageType==="read-mushaf"?
                                        <a className='cursor-pointer' onClick={()=>{navigateMushaf(item.surahNumber, item.scrollPos)}}>
                                            <div className="blue-gr-box alim-interactive-tile">
                                                <p className="alim-font-color-style text-xs dark:text-opacity-75 mb-2 truncate">{surahData.titleEn}</p>
                                                <div className="grid grid-cols-2">
                                                    <div className="col-span-1">
                                                        <h5 className="alim-font-color-style text-xs font-medium">Surah {surahData.index}</h5>
                                                    </div>
                                                    <div className="col-span-1">
                                                        <div className="text-right">
                                                        <h5 className="alim-font-color-style text-xs font-medium"> Juz {surahData.juz[0].index} </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h5 className="alim-font-color-style text-xs font-medium">{surahData.title}</h5>
                                                <div className="text-center py-4 px-2 mt-3 rounded recent-inner">
                                                    <h5 className="text-base font-medium mb-1 font-extrabold">{surahData.titleAr}</h5>
                                                    <p className="text-opacity-75 text-xs font-medium">{pageType}</p>
                                                </div>
                                            </div>
                                        </a>
                                    :
                                        <a href={surahLink}>
                                            <div className="blue-gr-box alim-interactive-tile">
                                                <p className="alim-font-color-style text-xs dark:text-opacity-75 mb-2 truncate">{item.titleMeaning}</p>
                                                <div className="grid grid-cols-2">
                                                    <div className="col-span-1">
                                                        <h5 className="alim-font-color-style text-xs font-medium">Surah {item.surahNumber}</h5>
                                                    </div>
                                                    <div className="col-span-1">
                                                        <div className="text-right">
                                                        <h5 className="alim-font-color-style text-xs font-medium"> Juz {item.juz} </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h5 className="alim-font-color-style text-xs font-medium">{item.title}</h5>
                                                <div className="text-center py-4 px-2 mt-3 rounded recent-inner">
                                                    <h5 className="text-base font-medium mb-1 font-extrabold">{item.arbTitle}</h5>
                                                    <p className="text-opacity-75 text-xs font-medium">{pageType}</p>
                                                </div>
                                            </div>
                                        </a>
                                }
                            </div>
                        )
                    }
                })
            }
        </>
    )
}

export default RecentInsightsKidsQuran;